"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var SYNC_API_BASE = 'extensions/sync/v1';
var ECOMM_API_BASE = 'extensions/ecomm/v1';

var EcommerceImportApi =
/*#__PURE__*/
function () {
  function EcommerceImportApi() {
    (0, _classCallCheck2.default)(this, EcommerceImportApi);
  }

  (0, _createClass2.default)(EcommerceImportApi, null, [{
    key: "getImportStatus",
    value: function getImportStatus() {
      return _apiClient.default.get(ECOMM_API_BASE + "/info/import-status");
    }
  }, {
    key: "getImportDetails",
    value: function getImportDetails() {
      return _apiClient.default.get(SYNC_API_BASE + "/imports/latest");
    }
  }]);
  return EcommerceImportApi;
}();

exports.default = EcommerceImportApi;
module.exports = exports.default;